import local from './props.local.json';
import prod  from './props.prod.json';

const properties = (process.env.NODE_ENV === 'production') ? prod : local;
export default properties;